var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 452 255",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 L432,0 C443.045695,-2.02906125e-15 452,8.954305 452,20 L452,255 L452,255 L0,255 L0,20 C-1.3527075e-15,8.954305 8.954305,-1.57345071e-14 20,0 Z",
    id: "04xjkslo2__wzql1zrjha"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "04xjkslo2__onmliw0bkb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#04xjkslo2__wzql1zrjha"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#04xjkslo2__wzql1zrjha"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2367FD",
    mask: "url(#04xjkslo2__onmliw0bkb)",
    d: "M239.4 -99.54545459999999A495.981818 183.409091 0 1 0 239.4 267.2727274A495.981818 183.409091 0 1 0 239.4 -99.54545459999999Z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.054641,
    mask: "url(#04xjkslo2__onmliw0bkb)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.977293,9.76532244e-14 L154.931838,40.0555556 L82.4318384,103 L9.93183844,40.0555556 L42.8863839,9.76532244e-14 L121.977293,9.76532244e-14 Z M108.40002,22.8888889 L56.4636566,22.8888889 L44.3363839,37.6522222 L82.4318384,70.7266667 L120.527293,37.6522222 L108.40002,22.8888889 Z",
    transform: "scale(-1 1) rotate(-14 -161.7506951 1939.21068477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitebg);
export default __webpack_public_path__ + "static/media/invitebg.3af149426543ae8922b0c05f95e243b4.svg";
export { ForwardRef as ReactComponent };